module.exports = __webpack_public_path__ + "static/media/18.1d4d5494.png";